import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import { Autoplay, FreeMode } from 'swiper/modules';
import './partner.css';

// Import des images
import paychex from '../../assets/images/Paychex.png';
import tektinz from '../../assets/images/tektinz.png';
import momo from '../../assets/images/mtn.png';
import aws from '../../assets/images/aws.png';
import ittiq1 from '../../assets/images/ittiq 1.png';
import kaba from '../../assets/images/kaba.png';

const MedtechPartners = () => {
  // Tableau des partenaires pour faciliter la maintenance
  const partners = [
    { image: paychex, name: 'Paychex' },
    { image: tektinz, name: 'Tektinz' },
    { image: momo, name: 'MoMo' },
    { image: aws, name: 'AWS' },
    { image: ittiq1, name: 'Ittiq1' },
    { image: kaba, name: 'Kaba' },
  ];

  return (
    <div className="medtech-partners-ticker">
      <div className="medtech-ticker-container">
        <Swiper
          modules={[Autoplay, FreeMode]}
          freeMode={true}
          loop={true}
          speed={7000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            280: { slidesPerView: 2, spaceBetween: 10 },
            375: { slidesPerView: 2.5, spaceBetween: 15 },
            480: { slidesPerView: 3, spaceBetween: 20 },
            640: { slidesPerView: 3.5, spaceBetween: 25 },
            768: { slidesPerView: 4, spaceBetween: 30 },
            992: { slidesPerView: 5, spaceBetween: 35 },
            1200: { slidesPerView: 6, spaceBetween: 40 },
            1440: { slidesPerView: 7, spaceBetween: 45 },
          }}
          className="medtech-ticker-swiper"
        >
          {/* Dupliquer les partenaires pour un défilement plus fluide */}
          {[...partners, ...partners, ...partners].map((partner, index) => (
            <SwiperSlide key={index} className="medtech-ticker-slide">
              <div className="medtech-ticker-logo-wrapper">
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="medtech-ticker-logo"
                />
                {/* <div className="medtech-ticker-tooltip">{partner.name}</div> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default MedtechPartners;